import React from 'react';
import { Box, TextField, TextFieldProps, Typography, alpha, useTheme } from '@mui/material';

interface StyledTextAreaProps extends Omit<TextFieldProps, 'variant'> {
  label: string;
  accentColor?: 'primary' | 'secondary' | 'success' | 'error';
}

const StyledTextArea: React.FC<StyledTextAreaProps> = ({ 
  label, 
  accentColor = 'primary',
  sx,
  ...props 
}) => {
  const theme = useTheme();
  
  const getAccentColor = () => {
    switch (accentColor) {
      case 'secondary': return theme.palette.secondary.main;
      case 'success': return theme.palette.success.main;
      case 'error': return theme.palette.error.main;
      default: return theme.palette.primary.main;
    }
  };

  const color = getAccentColor();

  return (
    <Box sx={{ position: 'relative' }}>
      <Typography 
        variant="caption" 
        sx={{ 
          position: 'absolute', 
          top: -10, 
          left: 12, 
          bgcolor: 'background.paper', 
          px: 1, 
          zIndex: 1, 
          color: color,
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.1em',
          fontSize: '0.65rem'
        }}
      >
        {label}
      </Typography>
      <TextField
        multiline
        fullWidth
        variant="outlined"
        InputProps={{
          sx: { 
            fontFamily: '"JetBrains Mono", monospace',
            fontSize: '0.85rem',
            lineHeight: 1.6,
            bgcolor: 'rgba(0,0,0,0.4)',
            borderRadius: 3,
            '& fieldset': { borderColor: 'rgba(255,255,255,0.1)' },
            '&:hover fieldset': { borderColor: alpha(color, 0.3) + ' !important' },
            '&.Mui-focused fieldset': { borderColor: color + ' !important' },
          }
        }}
        {...props}
      />
    </Box>
  );
};

export default StyledTextArea;
